import script from "./quickPaper.vue?vue&type=script&setup=true&lang=js"
export * from "./quickPaper.vue?vue&type=script&setup=true&lang=js"

import "./quickPaper.vue?vue&type=style&index=0&id=e3cb8ff4&lang=scss&scoped=true"

import exportComponent from "/var/www/ddup_czb/slczb_app_web/view/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e3cb8ff4"]])

export default __exports__